module.exports = __webpack_public_path__ + "logo2.a98e7366167d8d5c3f06.png";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/img/logo2.png
// module id = ../../../../../src/img/logo2.png
// module chunks = styles